import React from "react";
import { motion } from "framer-motion";
import { TREATMENTS } from "@/data/static";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Treatments() {
  return (
    <main className="pt-32 pb-16" data-testid="treatments-page">
      <div className="container-x">
        <motion.div initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.6}}>
          <span className="overline">Treatments</span>
          <h1 className="font-heading text-5xl sm:text-6xl tracking-tight font-light mt-3">Comprehensive <em className="italic font-medium text-primary">orthopedic</em> care</h1>
          <p className="mt-4 text-lg text-slate-600 max-w-3xl">From the most complex joint replacements to minimally invasive procedures, we deliver world-class outcomes.</p>
        </motion.div>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {TREATMENTS.map((t,i)=>{
            const Icon = t.icon;
            return (
              <motion.div key={t.slug} initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}} viewport={{once:true}} transition={{duration:0.5,delay:i*0.04}}
                className="group bg-white rounded-2xl border border-slate-100 p-7 shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all"
                data-testid={`treatment-${t.slug}`}>
                <div className="h-14 w-14 rounded-2xl bg-primary/8 text-primary flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-colors"><Icon className="w-7 h-7" strokeWidth={1.5}/></div>
                <h3 className="mt-6 font-heading text-xl font-medium">{t.title}</h3>
                <p className="mt-2 text-slate-500 leading-relaxed text-sm">{t.desc}</p>
                <Link to="/appointment" className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary">Book Consultation <ArrowRight className="w-4 h-4"/></Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </main>
  );
}
